export const HOW_WORK_STARTS_LIST = [{
  titleKey: 'steps.0.title',
  descriptionKey: 'steps.0.description'
}, {
  titleKey: 'steps.1.title',
  descriptionKey: 'steps.1.description'
}, {
  titleKey: 'steps.2.title',
  descriptionKey: 'steps.2.description'
}, {
  titleKey: 'steps.3.title',
  descriptionKey: 'steps.3.description'
}];
export type HowWorkStartsItem = (typeof HOW_WORK_STARTS_LIST)[number];